<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_478_3422)">
      <path
        d="M8.25 15.25H5.91667C5.60725 15.25 5.3105 15.1271 5.09171 14.9083C4.87292 14.6895 4.75 14.3928 4.75 14.0833V5.91667C4.75 5.60725 4.87292 5.3105 5.09171 5.09171C5.3105 4.87292 5.60725 4.75 5.91667 4.75H8.25M12.3333 12.9167L15.25 10M15.25 10L12.3333 7.08333M15.25 10L8.25 10"
        stroke="#373D3F"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_478_3422">
        <rect
          width="14"
          height="14"
          fill="white"
          transform="translate(3 3)"
        />
      </clipPath>
    </defs>
  </svg>
</template>